module.exports = __webpack_public_path__ + "static/media/favicon.67e97926.ico";